
    <div class="page404">
      <div class="inner">
        <div class="content">
          <h1 class="font-size-36 mb-2">Page not found</h1>
          <p class="mb-3">The page is deprecated, deleted, or does not exist at all</p>
          <h1 class="font-size-80 mb-4 font-weight-bold">404 —</h1>
          <a href routerLink="/" class="btn btn-light">
            &larr; Go back to the home page.
          </a>
        </div>
      </div>
    </div>
  